import { useEffect, useRef, useContext } from 'react';
import EarlyAccessContext from '../context/EarlyAccessContext';
import backgroundVideo from '../assets/background.mp4';

const VIDEO_PLAYBACK_RATE = 0.7;

const Hero = () => {
  const videoRef = useRef(null);
  const { setIsOpen } = useContext(EarlyAccessContext);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.playbackRate = VIDEO_PLAYBACK_RATE;
    }
  }, []);

  return (
    <section className="hero__content">
      <div className="hero__copy">
        <p className="eyebrow">Launching soon</p>
        <h1>The Game They'll Love. The Learning You'll Trust.</h1>
        <p className="lede">
          <strong>A nature-based adventure game for ages 5 to 8, built on the UK National Curriculum.</strong>
        </p>
        <p className="lede">
           Most educational apps are dull. Most fun apps aren't educational. Sprout Academy is the bridge. Our launch will cover maths skills and we'll expand to other subjects and year groups over time, read more about our plans in our <a href="/roadmap">public roadmap</a>.
        </p>
        <p className="lede">Founding Families early access opens soon.</p>
        <div className="hero__actions">
          <button className="btn btn--primary" onClick={() => setIsOpen(true)}>Join the early access list</button>
        </div>
      </div>
      <div className="hero__card">
        <div className="hero__preview">
          <video
            ref={videoRef}
            className="hero__preview-video"
            autoPlay
            muted
            loop
            playsInline
            poster=""
          >
            <source src={backgroundVideo} type="video/mp4" />
          </video>
        </div>
      </div>
    </section>
  );
};

export default Hero;
